import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { baseApiURL } from '../../baseUrl';
import { FiBriefcase, FiPlus, FiTrash2, FiExternalLink, FiUser, FiMail, FiPhone } from 'react-icons/fi';

const Companies = () => {
    const [companies, setCompanies] = useState([]);
    const [formData, setFormData] = useState({
        name: '', website: '', contactPerson: '', contactEmail: '', contactPhone: '', address: '', industryType: '', description: ''
    });

    useEffect(() => {
        fetchCompanies();
    }, []);

    const fetchCompanies = async () => {
        try {
            const res = await axios.get(`${baseApiURL()}/placement/companies/get`);
            if (res.data.success) {
                setCompanies(res.data.companies || []);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${baseApiURL()}/placement/companies/add`, formData);
            if (res.data.success) {
                toast.success(res.data.message);
                fetchCompanies();
                setFormData({ name: '', website: '', contactPerson: '', contactEmail: '', contactPhone: '', address: '', industryType: '', description: '' });
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error adding company');
        }
    };

    const handleDelete = async (id) => {
        try {
            const res = await axios.delete(`${baseApiURL()}/placement/companies/delete/${id}`);
            if (res.data.success) {
                toast.success(res.data.message);
                fetchCompanies();
            }
        } catch (error) {
            toast.error('Error deleting company');
        }
    };

    return (
        <div className="space-y-6">
            <div className="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs overflow-hidden">
                <div className="bento-header-banner flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="bg-indigo-50 dark:bg-indigo-950/60 border border-indigo-100 dark:border-indigo-800 p-2 rounded-xl text-indigo-600 dark:text-indigo-400">
                            <FiBriefcase className="text-xl" />
                        </div>
                        <div>
                            <h1 className="text-xl font-bold tracking-tight text-slate-900 dark:text-white">Partner Companies</h1>
                            <p className="text-slate-500 dark:text-slate-400 text-xs mt-0.5">
                                Onboard and manage corporate partners participating in campus placements.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="p-6 space-y-6">
                    {/* Add Company Form */}
                    <form onSubmit={handleSubmit} className="bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 p-5 rounded-2xl space-y-4">
                        <div className="flex items-center gap-2 text-xs font-bold text-slate-900 dark:text-white uppercase tracking-wider">
                            <FiPlus className="text-indigo-600 dark:text-indigo-400" />
                            <span>Add New Corporate Partner</span>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                            <input 
                                type="text" 
                                name="name" 
                                placeholder="Company Name *" 
                                value={formData.name} 
                                onChange={handleChange} 
                                required 
                                className="w-full px-3.5 py-2 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl text-xs font-semibold text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-indigo-500" 
                            />
                            <input 
                                type="text" 
                                name="website" 
                                placeholder="Website URL" 
                                value={formData.website} 
                                onChange={handleChange} 
                                className="w-full px-3.5 py-2 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl text-xs font-semibold text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-indigo-500" 
                            />
                            <input 
                                type="text" 
                                name="industryType" 
                                placeholder="Industry Type (e.g. IT, FinTech)" 
                                value={formData.industryType} 
                                onChange={handleChange} 
                                className="w-full px-3.5 py-2 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl text-xs font-semibold text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-indigo-500" 
                            />
                            <input 
                                type="text" 
                                name="contactPerson" 
                                placeholder="Contact Person Name" 
                                value={formData.contactPerson} 
                                onChange={handleChange} 
                                className="w-full px-3.5 py-2 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl text-xs font-semibold text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-indigo-500" 
                            />
                            <input 
                                type="email" 
                                name="contactEmail" 
                                placeholder="Contact Email" 
                                value={formData.contactEmail} 
                                onChange={handleChange} 
                                className="w-full px-3.5 py-2 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl text-xs font-semibold text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-indigo-500" 
                            />
                            <input 
                                type="text" 
                                name="contactPhone" 
                                placeholder="Contact Phone" 
                                value={formData.contactPhone} 
                                onChange={handleChange} 
                                className="w-full px-3.5 py-2 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl text-xs font-semibold text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-indigo-500" 
                            />
                        </div>
                        <div className="flex justify-end pt-1">
                            <button 
                                type="submit" 
                                className="px-5 py-2 bg-indigo-600 hover:bg-indigo-500 text-white text-xs font-bold rounded-xl shadow-xs transition cursor-pointer flex items-center gap-1.5"
                            >
                                <FiPlus />
                                <span>Save Company</span>
                            </button>
                        </div>
                    </form>

                    {/* Companies List */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {companies.length === 0 ? (
                            <div className="col-span-full text-center py-10 text-slate-400 text-xs font-semibold">
                                No partner companies added yet.
                            </div>
                        ) : (
                            companies.map(company => (
                                <div key={company._id} className="bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 p-5 rounded-2xl flex flex-col justify-between hover:shadow-sm transition">
                                    <div>
                                        <div className="flex items-start justify-between gap-2">
                                            <div>
                                                <h3 className="font-bold text-sm text-slate-900 dark:text-white">{company.name}</h3>
                                                <span className="inline-block px-2 py-0.5 mt-1 bg-indigo-50 dark:bg-indigo-950/60 text-indigo-700 dark:text-indigo-300 border border-indigo-100 dark:border-indigo-800/80 rounded-md text-[10px] font-bold uppercase tracking-wider">
                                                    {company.industryType || "General"}
                                                </span>
                                            </div>
                                            {company.website && (
                                                <a 
                                                    href={company.website.startsWith('http') ? company.website : `https://${company.website}`} 
                                                    target="_blank" 
                                                    rel="noreferrer" 
                                                    className="p-1.5 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 text-slate-600 dark:text-slate-400 hover:text-indigo-600 rounded-lg transition"
                                                    title="Visit Website"
                                                >
                                                    <FiExternalLink size={13} />
                                                </a>
                                            )}
                                        </div>

                                        <div className="mt-3.5 space-y-1.5 text-xs text-slate-600 dark:text-slate-400 border-t border-slate-200 dark:border-slate-800/80 pt-3">
                                            {company.contactPerson && (
                                                <p className="flex items-center gap-1.5">
                                                    <FiUser size={12} className="text-slate-400" />
                                                    <span className="font-medium">{company.contactPerson}</span>
                                                </p>
                                            )}
                                            {company.contactEmail && (
                                                <p className="flex items-center gap-1.5 truncate">
                                                    <FiMail size={12} className="text-slate-400" />
                                                    <span>{company.contactEmail}</span>
                                                </p>
                                            )}
                                            {company.contactPhone && (
                                                <p className="flex items-center gap-1.5">
                                                    <FiPhone size={12} className="text-slate-400" />
                                                    <span>{company.contactPhone}</span>
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="mt-4 pt-3 border-t border-slate-200 dark:border-slate-800/80 flex justify-end">
                                        <button 
                                            onClick={() => handleDelete(company._id)} 
                                            className="text-rose-600 dark:text-rose-400 hover:text-rose-700 text-xs font-bold flex items-center gap-1 cursor-pointer transition"
                                        >
                                            <FiTrash2 size={12} />
                                            <span>Remove</span>
                                        </button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Companies;
